import dayjs from 'dayjs';

/** 方向徽标（运行中 / 结束卡片共用） */
export const BIAS_META: Record<string, { text: string; cls: string }> = {
    bullish: {text: '▲偏多', cls: 'bull'},
    bearish: {text: '▼偏空', cls: 'bear'},
};

/** 价格（USDT，$,最多 8 位小数）；无数据返回 '--' */
export const fmtPx = (value?: number): string =>
    null == value ? '--' : `$${Number(value).toLocaleString('en-US', {maximumFractionDigits: 8})}`;

/** 平仓原因中文（整仓级） */
export const CLOSE_REASON_TEXT: Record<string, string> = {
    BIAS_REVERSAL: '方向反转',
    TP_SL: '止盈止损',
    FUNDING_NEGATIVE: '资金费转负',
    BASIS_ABNORMAL: '基差异常',
    EXPOSURE_STOP_LOSS: '敞口硬止损',
    COMPENSATION: '补偿退出',
    MANUAL: '手动平仓',
    STALE_RECORD: '残留记录清理',
};

/** 单腿退出原因中文（与后端 HedgeLegExitReason 常量对齐） */
export const LEG_EXIT_REASON_TEXT: Record<string, string> = {
    TAKE_PROFIT: '止盈离场',
    STOP_LOSS: '止损离场',
    MANUAL: '手动离场',
    PROTECT_TRIGGERED: '保护单触发',
};

/** 兼容后端 yyyy-MM-dd HH:mm:ss 与 ISO(含微秒小数) 形态，避免解析为 Invalid Date */
export const fmtTime = (value?: string | number | null): string => {
    if (null == value || '' === value) {
        return '--';
    }
    const text = String(value).trim().replace('T', ' ').replace(/\.\d+$/, '').slice(0, 19);
    const parsed = dayjs(text);
    return parsed.isValid() ? parsed.format('YYYY-MM-DD HH:mm:ss') : '--';
};

/** 简洁时间：当天 HH:mm，跨天 MM-DD HH:mm；full 供 Tooltip 展示完整时间 */
export const fmtCompactTime = (value?: string | null): { text: string; full: string } => {
    const full = fmtTime(value);
    if ('--' === full) {
        return {text: '--', full: '--'};
    }
    const parsed = dayjs(full);
    if (!parsed.isValid()) {
        return {text: full, full};
    }
    return {
        text: parsed.format(parsed.isSame(dayjs(), 'day') ? 'HH:mm' : 'MM-DD HH:mm'),
        full,
    };
};

export const fmtQty = (value?: number): string =>
    null == value ? '--' : (Math.abs(Number(value)) >= 1 ? Number(value).toFixed(4) : Number(value).toPrecision(4));

export const fmtPct = (value?: number): string => null == value ? '--' : `${Number(value).toFixed(1)}%`;

/** 盈亏（USDT + 百分比，盈利带 + 号）；数据不可用时返回 '--' */
export const fmtPnl = (pnl?: number, pct?: number): string => {
    if (null == pnl) {
        return '--';
    }
    const sign = Number(pnl) >= 0 ? '+' : '';
    const pctText = null == pct ? '' : ` (${Number(pct) >= 0 ? '+' : ''}${Number(pct).toFixed(2)}%)`;
    return `${sign}${Number(pnl).toFixed(2)}U${pctText}`;
};

/** 持仓时长（创建 → 结束）：<1h 显示分钟，<1d 显示时分，否则天+小时 */
export const fmtDuration = (from?: string | null, to?: string | null): string => {
    const start = dayjs(fmtTime(from));
    const end = dayjs(fmtTime(to));
    if (!start.isValid() || !end.isValid()) {
        return '--';
    }
    const minutes = Math.max(0, end.diff(start, 'minute'));
    if (minutes < 60) {
        return `${minutes}分`;
    }
    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
        return `${hours}小时${minutes % 60}分`;
    }
    return `${Math.floor(hours / 24)}天${hours % 24}小时`;
};
